import { render } from "./loading.vue?vue&type=template&id=2b75c904&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=2b75c904&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b75c904"]])

export default __exports__